import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import infoModel from '../listManage/infoModel.vue';
import { customerResource } from '@/views/system/customerManage/request';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { payInfoList, payCheck } from '../request2';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      infoShow: false,
      form: {
        infoType: 'PAY',
        customerId: undefined,
        applicationId: undefined,
        payNo: '',
        status: undefined,
        payType: undefined,
        searchNo: ''
      },
      typeList: [{
        key: 1,
        value: '微信'
      }, {
        key: 2,
        value: '支付宝'
      }, {
        key: 3,
        value: '银联'
      }, {
        key: 4,
        value: '易宝'
      }, {
        key: 5,
        value: '三方支付链接'
      }, {
        key: 6,
        value: '授信'
      }],
      applicationList: [],
      customerList: [],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '交易流水号'
        },
        dataIndex: 'payNo',
        key: 'payNo',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '投保流水号'
        },
        dataIndex: 'searchNo',
        key: 'searchNo',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '支付方式'
        },
        dataIndex: 'payType',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'payType'
        }
      }, {
        slots: {
          title: '订单金额'
        },
        dataIndex: 'orderAmount',
        key: 'orderAmount',
        align: 'center'
      }, {
        slots: {
          title: '应用名称'
        },
        dataIndex: 'applicationName',
        key: 'applicationName',
        align: 'center',
        customRender: text => {
          return {
            children: text || '—'
          };
        }
      }, {
        slots: {
          title: '交易状态'
        },
        dataIndex: 'statusName',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'statusName'
        }
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'action',
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 180
      }]
    };
  },
  async created() {
    if (this.$store.state.user.accountInfo.tag) {
      await this.getCustomerList();
    } else {
      this.form.customerId = this.$store.state.user.accountInfo.customerId;
      await this.customerChange();
    }
    await this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      let obj = this.form;
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      payInfoList(obj).then(res => {
        this.data = res.items;
        if (res.fieldConfig) {
          this.columns = res.fieldConfig;
        }
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async handleSee(val) {
      const res = await payCheck({
        customerId: val.customerId,
        payInfoId: val.id
      });
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoFrom.init(res);
      });
    },
    async getCustomerList() {
      this.customerList = await customerResource({});
      let arr = this.customerList.find(item => item.id == Number(sessionStorage.getItem('insuredCustomPayId')));
      this.form.customerId = arr ? Number(sessionStorage.getItem('insuredCustomPayId')) : this.customerList[0].id;
      sessionStorage.setItem('insuredCustomPayId', this.form.customerId);
    },
    async customerChange() {
      this.form.applicationId = undefined;
      if (this.form.customerId) {
        this.applicationList = await applicationResource({
          customerId: this.form.customerId,
          position: 'payment'
        });
        sessionStorage.setItem('insuredCustomPayId', this.form.customerId);
      } else {
        this.applicationList = [];
      }
    },
    reset() {
      this.form.customerId = undefined;
      this.form.applicationId = undefined;
      this.form.payNo = '';
      this.form.status = undefined;
      this.form.payType = undefined;
      this.form.searchNo = '';
    }
  }
};